import { inject, Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { AppState } from '@state';
import { UserAsset } from '@interfaces';

import * as actions from './decision-documents.actions';
import * as selectors from './decision-documents.selectors';

@Injectable()
export class DecisionDocumentsFacade {
  private readonly store = inject<Store<AppState>>(Store);
  private readonly actions = inject(Actions);

  public documents$ = this.store.select(selectors.selectDocuments);
  public loading$ = this.store.select(selectors.selectLoading);
  public removingIds$ = this.store.select(selectors.selectRemovingIds);

  public removeSuccess$ = this.actions.pipe(ofType(actions.removeDecisionDocumentSuccess));
  public removeError$ = this.actions.pipe(ofType(actions.removeDecisionDocumentError));

  public loadDocuments(userProcessId: string, opts?: { asConsultant?: boolean; errorMessageKey?: string }): void {
    this.store.dispatch(
      actions.loadDecisionDocuments({
        userProcessId,
        asConsultant: opts?.asConsultant,
        errorMessageKey: opts?.errorMessageKey,
      })
    );
  }

  public removeDocument(
    userProcessId: string,
    userAsset: UserAsset,
    opts?: {
      asConsultant?: boolean;
      successMessageKey?: string;
      errorMessageKey?: string;
      reloadErrorMessageKey?: string;
    }
  ): void {
    this.store.dispatch(
      actions.removeDecisionDocument({
        userProcessId,
        userAsset,
        asConsultant: opts?.asConsultant,
        successMessageKey: opts?.successMessageKey,
        errorMessageKey: opts?.errorMessageKey,
        reloadErrorMessageKey: opts?.reloadErrorMessageKey,
      })
    );
  }
}
